module.exports = __webpack_public_path__ + "img/EXTERIOR-ERTIGA-BOOSTER-GREEN-3.8696928a.jpg";